/**
 * @file    AboutPage.jsx
 *          About page for DCP
 *
 *          Uses `react-hook-forms` to handle form validation.
 *
 * @author  Jordan Cartlidge <jordan@kingsds.network>
 * @author  Kevin Yu <kevin@distributive.network>
 * @date    June 2022
 */
import { useLocation } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { useTranslation, Trans } from 'react-i18next';
import { Heading } from '@/components/Elements/Heading';
import './AboutPage.css';


const { VITE_ASSETS_PATH } = import.meta.env;

/**
 * Render the about page.
 *
 * @param   {object}      props Component props.
 * @returns {JSX.Element}       The rendered component.
 */
export function AboutPage(_props)
{
  const { t } = useTranslation();
  const location = useLocation();

  const [, page] = location.pathname.split('/');

  return (
    <Layout contentClassName={page} id="aboutPage">
      <div className="about-header">
        <img src={`${VITE_ASSETS_PATH}/img/logo-banner.png`} alt="DCP" className="about-banner-logo" />
      </div>
      <section>
        <Heading heading={t('welcome_to_distributive_compute_protocol')} />

        {/* Company Specific Disclaimer */}
        <div className='branded-content'>
          <p><Trans i18nKey={'disclaimer'} ns='copy'></Trans></p>
          <hr />
          <p className='about-powered-by-title'><b><Trans i18nKey={'powered_by_dcp'} ns='copy'></Trans></b></p>
        </div>

        <p>
          {t('about_page_par_1')}
        </p>
        <p>
          <Trans i18nKey={'about_page_par_2'} values={{ worker: t('worker') }}>
            Use the <b>Worker</b> tab to use your computer cores to contribute to
            world wide distributed compute projects (and earn Compute Credits while you do).
          </Trans>
        </p>
        <p>
          <Trans i18nKey={'about_page_par_3'} values={{ accounts: t('accounts') }}>
            Check out the <b>Accounts</b> tab to see and manage your Compute Credits.
          </Trans>
          {t('about_page_par_4')}&nbsp;<a href="https://docs.dcp.dev/" target="_blank" rel="noreferrer">{t('documentation')}</a>
          {t('about_page_par_4_ending')}{' '}
          <a href="mailto:info@distributive.network">
            {t('email')}
          </a>
          {t('period')}
        </p>
      </section>

      <img src={`${VITE_ASSETS_PATH}/img/powered-by-dcp.png`} alt="DCP" className="about-powered-by" />
    </Layout>
  );
}
